import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import { ClassicEditor } from 'ckeditor5';
import 'ckeditor5/ckeditor5.css';
import './CkEditor.scss';
import TooltipComponent from '../../tooltip/TooltipComponent';
import { editorConfig } from './CkEditorConfig';

const CKEditorComponent = ({
    data,
    isdisable,
    placeholder,
    onCKEditorChange,
    inputInfoConfig,
    ...editorProps
}) => {
    const [editorData, setEditorData] = useState(data || '<div></div>'); // Initialize with empty div or provided data

    // Update the state when the data prop changes (external data change)
    useEffect(() => {
        setEditorData(data);
    }, [data]);

    return (
        <div className="ckeditor-sec">
            <CKEditor
                editor={ClassicEditor}
                data={editorData}
                onChange={(event, editor) => {
                    const newData = editor.getData();
                    if (newData !== editorData) {
                        setEditorData(newData); // Update internal state
                        onCKEditorChange(newData, editor);
                    }
                }}
                config={editorConfig}
                disabled={isdisable}
                {...editorProps}
            />
            {inputInfoConfig?.isInfoIcon && (
                <TooltipComponent
                    iconName={inputInfoConfig?.iconName}
                    message={inputInfoConfig?.message}
                />
            )}
        </div>
    );
};

CKEditorComponent.propTypes = {
    data: PropTypes.string,
    isdisable: PropTypes.bool,
    onCKEditorChange: PropTypes.func.isRequired,
    placeholder: PropTypes.string,
    editorProps: PropTypes.shape({
        config: PropTypes.shape({
            toolbar: PropTypes.arrayOf(PropTypes.string),
        }),
    }),
    inputInfoConfig: PropTypes.shape({
        isInfoIcon: PropTypes.bool,
        iconName: PropTypes.string,
        message: PropTypes.string,
    }),
};

CKEditorComponent.defaultProps = {
    data: '',
    isdisable: false,
    editorProps: {}
};

export default CKEditorComponent;
